export default __webpack_public_path__ + "static/media/imd.37584cd2.jpg";